"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealersListStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        list: (_a = {
                backgroundColor: theme.palette.background.paper,
                position: 'relative',
                overflow: 'auto',
                height: 435
            },
            _a[theme.breakpoints.down('sm')] = {
                maxHeight: 800,
            },
            _a),
    });
}, { name: 'Checkout_DealersList' });
exports.default = dealersListStyles;
